import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";
import { Helmet } from "react-helmet";
import * as yup from "yup";

import './Privacy.scss'

import {
    Navbar,
    Header,
    StepHeader,
    FormBox,
    Footer
} from '../../components/_index';
import { Box } from '@material-ui/core';
import { withTranslation } from 'react-i18next';

export default withTranslation()(function Privacy({t, i18n}) {
    
    const [dnsData, setDnsData] = useState(null);

    const getDnsData = async () => {
    const response = await fetch(`https://dns.google.com/resolve?name=` + window.location.hostname + `&type=1`);
    const jsonData = await response.json();
        return jsonData;
    };

    useEffect(() => {
        getDnsData().then(data => {
        setDnsData(data);
        }); 
    }, []);

    if (dnsData === null) {
        return null;
    }
    
    const siteID = () => {
        console.log("DNS Status Code: ", dnsData.Status);
        if (dnsData.Status.toString() === "0") {
            if(dnsData.Answer[0].data.toString() === "202.128.244.150") {
                console.log(">>> UAT <<<");
                return "0";
            }
            else if (dnsData.Answer[0].data.toString() === "202.128.229.85") {
                console.log(">>> KP Server <<<");
                return "1";
            }
            else if (dnsData.Answer[0].data.toString() === "202.128.244.85") {
                console.log(">>> SP Server <<<");
                return "2";
            }
            else if (dnsData.Answer[0].name.toString() === "epas.td.gov.hk.") {
                if (dnsData.Answer[1].data.toString() === "202.128.229.85") {
                    console.log(">>> KP Server <<<");
                    return "1";
                }
                else if (dnsData.Answer[1].data.toString() === "202.128.244.85") {
                    console.log(">>> SP Server <<<");
                    return "2";
                }
            }
        }
        else {
            console.log(">>> Localhost <<<");
            return "0";
        }
    }
    
    return (
        <main>
            <Helmet>
                <title>{`Screen ID: SC-790-`+siteID()+'-016'}</title>
            </Helmet>
            <div className="wrapper Privacy">
                <Header langLock="langLocked" />
                <div className="mainWrapper">
                    <div className="contentWrapper">
                        <FormBox header={t("terms.privacy.title")}>
                            <Box
                                p={5}
                                bgcolor="tnc.main"
                            >
                                <b>{t("terms.privacy.sectionTitle1")}</b>
                                <ol>
                                    <li value="1">{t("terms.privacy.subtitle1")}</li>
                                    {
                                        t("terms.privacy.subContent1", {returnObjects: true}).map((content)=>(
                                            <li style={{listStyleType: "none"}}>{content}</li>
                                        ))
                                    }
                                    <li value="2">{t("terms.privacy.subtitle2")}</li>
                                </ol>
                                <b>{t("terms.privacy.sectionTitle2")}</b>
                                <ol>
                                    <li value="3">{t("terms.privacy.subtitle3")}</li>
                                    {
                                        t("terms.privacy.subContent2", {returnObjects: true}).map((content)=>(
                                            <li style={{listStyleType: "none"}}>{content}</li>
                                        ))
                                    }
                                </ol>
                                <b>{t("terms.privacy.sectionTitle3")}</b>
                                <ol>
                                    <li value="4">{t("terms.privacy.subtitle4")}</li>
                                </ol>
                                <b>{t("terms.privacy.sectionTitle4")}</b>
                                <ol>
                                    <li value="5">{t("terms.privacy.subtitle5")}</li>
                                </ol>
                            </Box>
                        </FormBox>
                    </div>
                </div>
            </div>
            <Footer />
        </main>
    )
})
